const highlightKeywords = [
  'React',
  'TypeScript',
  'JavaScript',
  'Node.js',
  'Express',
  'Redux',
  'Next.js',
  'Docker',
  'GraphQL',
  'REST',
  'Angular',
  'Flutter',
  'API Gateway',
  'Microservices',
  'AWS Lambda',
  '.NET',
  'Next.js',
  'Spring Boot'
]

export default highlightKeywords
